import { ChemicalTransDto } from "src/dtos/chemicalTrans/chemicalTransDto";

/**
 * TQC1040_R01 수입검사 행 DTO
 * 입고(INCOMING) 내역(ChemicalTransDto) + 검사값(inspectValue1~6)
 */
export interface TQC1040_R01Dto extends ChemicalTransDto {
	// 검사항목 (Y/N)
	inspectValue1: string;      // 누출없을것
	inspectValue2: string;      // 약품명부착
	inspectValue3: string;      // 납품일자기록
	inspectValue4: string;      // 유독물경고
	inspectValue5: string;      // 터짐없음
	inspectValue6: string;      // M.Sheet 제출

	// 조인 필드
	customNm: string;           // 공급처(거래처)명
	inspectEmpNm: string;       // 검사자명
	eqmUnit: string;            // 단위
	equipmentNm: string;        // 약품명

	// UI 상태
	inserted: boolean;
	isModified: boolean;
}

export const defaultTQC1040_R01Dto: TQC1040_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectDt: '',
	eqmCd: '',
	inspectCycle: '',
	inspectType: 'INCOMING',
	compCd: '',
	customCd: '',
	inspectTime: '',
	transportQty: 0,
	inspectEmpno: '',
	remark: '',

	inspectValue1: 'N',
	inspectValue2: 'N',
	inspectValue3: 'N',
	inspectValue4: 'N',
	inspectValue5: 'N',
	inspectValue6: 'N',

	customNm: '',
	inspectEmpNm: '',
	eqmUnit: '',
	equipmentNm: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: '',
};

/** 검사항목 6개 컬럼 필드명 목록 */
export const TQC1040_R01_INSPECT_VALUE_FIELDS: (keyof TQC1040_R01Dto)[] = [
	'inspectValue1',
	'inspectValue2',
	'inspectValue3',
	'inspectValue4',
	'inspectValue5',
	'inspectValue6',
];

/** 빈 검사값을 기본값 'N'으로 채운다. (SYS2010_R01 기본값 패턴) */
export const normalizeInspectValues = (row: TQC1040_R01Dto): TQC1040_R01Dto => {
	const next = { ...row };
	TQC1040_R01_INSPECT_VALUE_FIELDS.forEach((field) => {
		const v = next[field];
		if (v === '' || v === null || v === undefined) {
			(next[field] as string) = 'N';
		}
	});
	return next;
};
